import React, { useState, useEffect } from "react";

const TableModal = ({ initialTable = null, tables = [], shifts = [], selectedDate = null, currentFloor = "inside",onClose }) => {
  const [selectedTable, setSelectedTable] = useState(initialTable?.id || "");
  const [name, setName] = useState("");
  const [people, setPeople] = useState(1);
  const [reservationDate, setReservationDate] = useState("");
  const [selectedShift, setSelectedShift] = useState("4");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  // inicijalni datum
  useEffect(() => {
    if (selectedDate) {
      // Ako je selectedDate Date objekt (iz kalendara)
      const d = new Date(selectedDate);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      setReservationDate(`${yyyy}-${mm}-${dd}`);
    } else {
      // Fallback na današnji datum
      setReservationDate(new Date().toLocaleDateString("en-CA"));
    }
  }, [selectedDate]);

  const handleShiftChange = (e) => {
    const value = e.target.value;
    setSelectedShift(value);

    if (value === "manual") {
      setStartTime("");
      setEndTime("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!selectedTable) return setError("Odaberi stol!");
    if (!name) return setError("Unesi ime gosta!");

    const tableObj = tables.find((t) => t.id === Number(selectedTable));
    if (!tableObj) return setError("Stol ne postoji!");
    if (people > tableObj.seats) return setError("Previše osoba za stol!");

    try {
      const body = {
        table_id: Number(selectedTable),
        guest_name: name,
        guests: people, 
        reservation_date: reservationDate,
        shift_id: selectedShift !== "manual" ? selectedShift : null,
        note: note || "",
      };

      if (selectedShift === "manual" && startTime && endTime) {
        body.start_datetime = `${reservationDate}T${startTime}:00`;
        body.end_datetime = `${reservationDate}T${endTime}:00`;
      }

      if (selectedShift !== "manual") {
        const shift = shifts.find(s => String(s.id) === String(selectedShift));
        if (shift && reservationDate === new Date().toLocaleDateString("en-CA")) {
          const now = new Date();
          const nowMinutes = now.getHours() * 60 + now.getMinutes();
          const [shiftHour, shiftMin] = shift.start_time.split(":").map(Number);
          const shiftMinutes = shiftHour * 60 + shiftMin;

          if (shiftMinutes < nowMinutes) {
            return setError("Odabrani termin je već počeo ili završio!");
          }
        }
      }      

      const response = await fetch("/reservations/api/reservations/create/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (response.ok) onClose();
      else setError(result.error || "Greška na serveru");
    } catch (err) {
      console.error(err);
      setError("Mrežna greška – pokušaj ponovo!");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-gray-900 border border-[#c1b428] text-white p-4 rounded-xl shadow-2xl w-full max-w-xs max-h-[85vh] overflow-y-auto text-sm">

        {/* Naslov */}
        <h2 className="text-lg font-bold mb-3 text-center text-[#c1b428]">
          Nova rezervacija
        </h2>

        {/* Greška */}
        {error && (
          <div className="mb-3 p-2 bg-red-900 border border-[#c1b428] rounded-lg text-[#c1b428] text-xs">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-2">

        {/* Izbor stola */}
        <div className="space-y-1">
          <label className="block text-[#c1b428] font-semibold text-xs">Stol:</label>
          <select
            value={selectedTable}
            onChange={(e) => setSelectedTable(e.target.value)}
            className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
          >
            <option value="">— Odaberi stol —</option>

            {/* Trenutni floor prvi */}
            {(() => {
              const indoor = tables
                .filter(t => !t.is_outdoor)
                .sort((a, b) => a.label.localeCompare(b.label));
              const outdoor = tables
                .filter(t => t.is_outdoor)
                .sort((a, b) => a.label.localeCompare(b.label));

              const primary = currentFloor === "outside" ? outdoor : indoor;
              const secondary = currentFloor === "outside" ? indoor : outdoor;

              return (
                <>
                  {primary.length > 0 && (
                    <optgroup label={currentFloor === "outside" ? "🌿 Vanjski stolovi" : "🏠 Unutarnji stolovi"}>
                      {primary.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.label} ({t.seats} mjesta)
                        </option>
                      ))}
                    </optgroup>
                  )}
                  {secondary.length > 0 && (
                    <optgroup label={currentFloor === "outside" ? "🏠 Unutarnji stolovi" : "🌿 Vanjski stolovi"}>
                      {secondary.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.label} ({t.seats} mjesta)
                        </option>
                      ))}
                    </optgroup>
                  )}
                </>
              );
            })()}
          </select>
        </div>

          {/* Ime */}
          <div className="space-y-1">
            <label className="block text-[#c1b428] font-semibold text-xs">Ime gosta:</label>
            <input
              type="text"
              className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* Broj ljudi */}
          <div className="space-y-1">
            <label className="block text-[#c1b428] font-semibold text-xs">Broj osoba:</label>
            <input
              type="number"
              className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
              min="1"
              value={people}
              onChange={(e) => setPeople(Number(e.target.value))}
            />
          </div>

          {/* Datum */}
          <div className="space-y-1">
            <label className="block text-[#c1b428] font-semibold text-xs">Datum:</label>
            <input
              type="date"
              className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
              value={reservationDate}
              onChange={(e) => setReservationDate(e.target.value)}
            />
          </div>

          {/* Shiftovi */}
          <div className="space-y-1">
            <label className="block text-[#c1b428] font-semibold text-xs">Vrijeme:</label>
            <select
              value={selectedShift}
              onChange={handleShiftChange}
              className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
            >
              {shifts.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name} ({s.start_time.slice(0,5)} - {s.end_time.slice(0,5)})
                </option>
              ))}

              <option value="manual">Ručno</option>
            </select>
          </div>

          {/* Ručni unos vremena */}
          {selectedShift === "manual" && (
            <div className="grid grid-cols-2 gap-2">
              <input
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                onBlur={(e) => {
                  const picked = e.target.value;
                  if (!picked) return;

                  const today = new Date();
                  const todayStr = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}-${String(today.getDate()).padStart(2,"0")}`;

                  // Zabrana između ponoći i 8h
                  const [h] = picked.split(":").map(Number);
                  if (h >= 0 && h < 8) {
                    setStartTime("08:00");
                    return;
                  }

                  // Zabrana u prošlosti (samo za danas)
                  if (reservationDate === todayStr) {
                    const now = `${String(today.getHours()).padStart(2,"0")}:${String(today.getMinutes()).padStart(2,"0")}`;
                    if (picked < now) {
                      setStartTime(now);
                      return;
                    }
                  }

                  setStartTime(picked);
                }}
                className="bg-gray-800 text-white p-2 rounded border border-[#c1b428]"
              />
              <input
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                onBlur={(e) => {
                  const picked = e.target.value;
                  if (!picked) return;

                  const [h] = picked.split(":").map(Number);

                  // Zabrana između ponoći i 8h → postavi 00:00
                  if (h > 0 && h < 8) {
                    setEndTime("00:00");
                    return;
                  }

                  setEndTime(picked);
                }}
                className="bg-gray-800 text-white p-2 rounded border border-[#c1b428]"
              />
            </div>
          )}

          {/* Napomena */}
          <textarea
            rows="2"
            className="bg-gray-800 text-white p-2 w-full rounded border border-[#c1b428]"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Napomena..."
          />

          {/* Gumbi */}
          <div className="flex justify-end gap-2 pt-3">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1 bg-gray-700 text-white rounded hover:bg-gray-600 text-xs"
            >
              Odustani
            </button>

            <button
              type="submit"
              className="px-3 py-1 bg-[#c1b428] text-black rounded font-bold hover:bg-yellow-500 text-xs"
            >
              Spremi
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default TableModal;
